export default "/packs/images/bookmark~78c01a5586ef8e2cd31d92bdcfdee85d.svg";